import { inject, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { markdownService } from '@src/app/core/services/markdown.service.js'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { NcDatePipe } from './nc-date.pipe.js'

@Pipe({
  name: 'tmd',
  standalone: false,
})
export class MarkdownPipe implements PipeTransform {
  private translateService = inject(TranslateService)
  private store = inject(SignalStore)
  htmlValue!: string

  transform(key: string, tmdParams?: any): string {
    const params: any = {}

    if (tmdParams) {
      Object.keys(tmdParams).forEach(key => {
        const value = tmdParams[key]

        if (value instanceof Date) {
          params[key] = new NcDatePipe().transform(
            value,
            this.store.$userLocale().supportedLanguage,
          )
        } else {
          params[key] = value
        }
      })
    }

    this.translateService.get(key, params).subscribe(value => {
      const valueWithoutPlaceholders = value.replace(/{{\w+}}/g, '')
      this.htmlValue = markdownService.parse(valueWithoutPlaceholders)
    })

    return this.htmlValue
  }
}
